import { useEffect } from 'react';
import { useEstablishmentStore } from '../../store/establishmentStore';
import { useThemeStore } from '../../store/themeStore';
import { getEstablishmentColors } from '../../constants/brandColors';
import { applyEstablishmentDocumentColors } from '../../utils/establishmentDocumentTheme';

/**
 * Hook para aplicar as cores do estabelecimento como tema global
 * Aplica cores primárias e secundárias em CSS variables que podem ser usadas em toda a aplicação
 */
export const useEstablishmentTheme = () => {
  const { establishment } = useEstablishmentStore();
  const { colors: themeColors, setColors, mode } = useThemeStore();

  // Atualizar themeStore se o estabelecimento tiver cores e o themeStore ainda não tiver sido atualizado
  useEffect(() => {
    if (establishment?.primaryColor && establishment?.secondaryColor) {
      // Só atualiza se as cores do estabelecimento forem diferentes das cores atuais do themeStore
      if (
        themeColors.primary !== establishment.primaryColor ||
        themeColors.secondary !== establishment.secondaryColor
      ) {
        setColors({
          primary: establishment.primaryColor,
          secondary: establishment.secondaryColor,
        });
      }
    }
  }, [establishment, themeColors, setColors]);

  useEffect(() => {
    applyEstablishmentDocumentColors({
      primary: themeColors.primary,
      secondary: themeColors.secondary,
      navAccentIsDark: mode === 'dark',
    });
  }, [themeColors, mode]);

  // Retornar as cores correntes (sempre sincronizadas com o tema aplicado)
  return getEstablishmentColors(themeColors.primary, themeColors.secondary);
};
